import React from "react";
import { Button } from "react-bootstrap";

import { useTranslation } from "react-i18next";

export default function ExportToExcelButton({ handler, disabled }) {
  const {
    t,
  } = useTranslation();

  return (
    <div className="float-right">
      <Button disabled={disabled} onClick={handler} variant="success" size="md" className="btn-outline" title={t("common.labels.exportDataToExcel")}>
        {disabled ? <i className="fa fa-circle-notch fa-lg fa-spin"></i> : <i className="fa fa-file-excel fa-lg" />}
      </Button>
    </div>
  );
}
